module.exports = __webpack_public_path__ + "static/media/VDWXRTKC1.066c6441.png";